import styled from "styled-components"

/** ActionsFooter is used for top-level "actions" below some object of
 * interest, such as a table or list of items. Used to contain buttons
 * that manipulate the object of interest. */
const ActionsFooter = styled.div`
  padding: 1rem 0;
  text-align: right;
`

export default ActionsFooter
